import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AgroclimaPage from './pages/AgroclimaPage';
import AvisosPage from './pages/AvisosPage';
import PreciosPage from './pages/PreciosPage';
import FormacionPage from './pages/FormacionPage';
import ComerciosPage from './pages/ComerciosPage';
import MasPage from './pages/MasPage';
import AjustesPage from './pages/AjustesPage';
import AcercaDePage from './pages/AcercaDePage';
import MapaCultivosPage from './pages/MapaCultivosPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/agroclima" element={<AgroclimaPage />} />
          <Route path="/avisos" element={<AvisosPage />} />
          <Route path="/precios" element={<PreciosPage />} />
          <Route path="/formacion" element={<FormacionPage />} />
          <Route path="/comercios" element={<ComerciosPage />} />
          <Route path="/mapa-cultivos" element={<MapaCultivosPage />} />
          <Route path="/mas" element={<MasPage />} />
          <Route path="/mas/ajustes" element={<AjustesPage />} />
          <Route path="/mas/acerca" element={<AcercaDePage />} />
          <Route path="/mas/formacion" element={<FormacionPage />} />
          <Route path="/mas/comercios" element={<ComerciosPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
